/*
 *
 *  actions
 *
 */

import {
  //LOAD_MONTHLY_RECORD
  LOAD_MONTHLY_RECORD,
  LOAD_MONTHLY_RECORD_SUCCESS,
  LOAD_MONTHLY_RECORD_ERROR,

   LOAD_ATTENDENCE,
  LOAD_ATTENDENCE_SUCCESS,
  LOAD_ATTENDENCE_ERROR,
//LOAD_CHECKINOUT
  LOAD_CHECKINOUT,
  LOAD_CHECKINOUT_SUCCESS,
  LOAD_CHECKINOUT_ERROR,
} from "./constants";

export function loadRecordsCacheHit() {
  return {
    // type: LOAD_RECORDS_VALID_CACHE  organization_list
  };
}


//loadMonthlyRecord
export function loadMonthlyRecord(searchFilter) {
  return {
    type: LOAD_MONTHLY_RECORD,
    searchFilter,
  };
}

export function loadMonthlyRecordSuccess( monthly_list, success) {
  return {
    type: LOAD_MONTHLY_RECORD_SUCCESS,
     monthly_list,
    success,
  };
}

export function loadMonthlyRecordError(error) {
  return {
    type: LOAD_MONTHLY_RECORD_ERROR,
    error,
  };
}

//loadCheckinOut
export function loadCheckinOut(searchFilter) {
  return {
    type: LOAD_CHECKINOUT,
    searchFilter,
  };
}

export function loadCheckinOutSuccess(checkinOut_list, success) {
  return {
    type: LOAD_CHECKINOUT_SUCCESS,
    checkinOut_list,
    success,
  };
}

export function loadCheckinOutError(error) {
  return {
    type: LOAD_CHECKINOUT_ERROR,
    error,
  };
}
//loadAttendence
export function loadAttendence(searchFilter) {
  return {
    type: LOAD_ATTENDENCE,
    searchFilter,
  };
}

export function loadAttendenceSuccess(attendence_list, success) {
  return {
    type: LOAD_ATTENDENCE_SUCCESS,
    attendence_list,
    success,
  };
}

export function loadAttendenceError(error) {
  return {
    type: LOAD_ATTENDENCE_ERROR,
    error,
  };
}
const actions = {
 
  loadMonthlyRecord,
  loadMonthlyRecordSuccess,
  loadMonthlyRecordError,
  loadCheckinOut,
  loadCheckinOutSuccess,
  loadCheckinOutError,
  loadRecordsCacheHit,
  loadAttendence,
  loadAttendenceSuccess,
  loadAttendenceError
};

export default actions;
